import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useExecuteLcrWorksheetQuery = (lcrSessionId, worksheetId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    async (queryData) => {
      const { data } = await axiosInstance.post(
        liveCleanroom(orgId).executeWorksheetQuery(lcrSessionId, worksheetId),
        queryData,
      );
      return data?.response;
    },
    {
      onSuccess: () => {
        dispatch(
          showAlert({
            message: 'Query sent for execution. This may take some time.',
            type: 'success',
          }),
        );
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error executing query',
            type: 'error',
          }),
        );
      },
    },
  );
};
